import { ResponsiveLine } from "@nivo/line";
import { useState, useEffect } from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import { tokens } from "../theme";
import { Box } from "@mui/material";

const LineChart = ({
  data,
  isCustomLineColors = false,
  isDashboard = false,
  minValue,
  maxValue,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [todayDateTime, setTodayDateTime] = useState("");
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const day = String(now.getDate()).padStart(2, "0");
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const year = now.getFullYear();
      let hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const isAM = hours < 12;
      hours = hours % 12 || 12;
      const ampm = isAM ? "AM" : "PM";
      hours = String(hours).padStart(2, "0");
      const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
      setTodayDateTime(formattedDateTime);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        minHeight: isMobile ? "300px" : isTablet ? "400px" : "500px",
        marginBottom: isMobile || isTablet ? "40px" : 0, // مساحة للتاريخ في الموبايل/التابلت
      }}
    >
      {/* صندوق الرسم البياني */}
      <Box
        sx={{
          width: "100%",
          height: "100%",
        }}
      >
        <ResponsiveLine
          key={JSON.stringify(data)}
          data={data}
          theme={{
            axis: {
              domain: {
                line: {
                  stroke: colors.grey[100],
                },
              },
              legend: {
                text: {
                  fill: colors.grey[100],
                  fontSize: isDesktop ? 14 : 12,
                },
              },
              ticks: {
                line: {
                  stroke: colors.grey[100],
                  strokeWidth: 1,
                },
                text: {
                  fill: colors.grey[100],
                  fontSize: isDesktop ? 12 : 10,
                },
              },
            },
            legends: {
              text: {
                fill: colors.grey[100],
                fontSize: isDesktop ? 12 : 8,
              },
            },
            tooltip: {
              container: {
                color: colors.primary[500],
                fontSize: isDesktop ? 14 : 12,
              },
            },
          }}
          colors={isDashboard ? { datum: "color" } : { scheme: "nivo" }}
          margin={{
            top: isDesktop ? 30 : 20,
            right: isDesktop ? 40 : isTablet ? 20 : 10,
            bottom: isDesktop ? 80 : isMobile ? 40 : 50, // تقليل المساحة السفلية في الموبايل/التابلت
            left: isDesktop ? 60 : isMobile ? 40 : 50,
          }}
          xScale={{ type: "point" }}
          yScale={{
            type: "linear",
            min: minValue ? minValue - 0.005 : "auto",
            max: maxValue ? maxValue + 0.005 : "auto",
            stacked: true,
            reverse: false,
          }}
          // curve="monotoneX"
          yFormat=" >-.2f"
          axisTop={null}
          axisRight={null}
          axisBottom={{
            orient: "bottom",
            tickSize: 5,
            tickPadding: 5,
            tickRotation: isMobile ? -90 : -45,
            legendOffset: isDesktop ? 60 : 40,
            legendPosition: "middle",
          }}
          axisLeft={{
            orient: "left",
            tickValues: 5,
            tickSize: 3,
            tickPadding: 5,
            tickRotation: 0,
            legendOffset: isDesktop ? -50 : -40,
            legendPosition: "middle",
          }}
          enableGridX={false}
          enableGridY={true}
          pointSize={isDesktop ? 8 : isMobile ? 4 : 6}
          pointColor={{ theme: "background" }}
          pointBorderWidth={isDesktop ? 3 : 2}
          pointBorderColor={{ from: "serieColor" }}
          pointLabelYOffset={-12}
          useMesh={true}
          enableArea={true}
          areaOpacity={0.15}
          areaBlendMode="normal"
          areaColor={{ from: "serieColor", modifiers: [["darker", 1.6]] }}
          areaBaselineValue={minValue || 0}
          animate={true}
          motionConfig="gentle"
        />
      </Box>

      {/* التاريخ والوقت - خارج الصندوق في الموبايل/التابلت */}
      <Box
        sx={{
          position: isMobile || isTablet ? "static" : "absolute",
          bottom: isDesktop ? -80 : "auto",
          top: isMobile || isTablet ? "calc(100% + 10px)" : "auto",
          left: 0,
          right: 0,
          textAlign: "center",
          color: colors.grey[100],
          fontSize: isDesktop ? "2rem" : "0.875rem",
          padding: "8px",
          backgroundColor:
            isMobile || isTablet ? "transparent" : colors.primary[400],
          borderRadius: "4px",
          margin: isDesktop ? "0 100px" : isMobile ? "0" : "0 20px",
          zIndex: 2,
        }}
      >
        {todayDateTime}
      </Box>
    </Box>
  );
};

export default LineChart;
